export default [
  {
    key: '练习册',
    category: ['jiaofu'],
    value: 1
  },
  {
    key: '导论',
    category: [],
    value: 2
  },
  {
    key: '串讲',
    category: [],
    value: 3
  },
  {
    key: '试卷',
    category: [
      'mijuan_danyuanceshi',
      'mijuan_qizhongqimo',
      'mijuan_qizhongqimo0',
      'mijuan_shengxuekaoshi',
      'mijuan_zhuantishijuan'
    ],

    value: 4
  },
  {
    key: '课本点读',
    category: ['kebendiandu'],
    value: 5
  },
  {
    key: '绘本点读',
    category: ['huibendiandu'],
    value: 6
  },
  {
    key: '课本',
    category: ['keben'],
    value: 9
  },
  {
    key: '听写',
    category: ['tingxie'],
    value: 10
  },
  {
    key: '阅读',
    category: ['yuedu'],
    value: 11
  },
  {
    key: '知识点',
    category: ['zhishidian'],
    value: 12
  },
  {
    key: '名著阅读',
    value: 13,
    category: ['mingzhuyuedu']
  }
]
